import xhrWrapper from './xhrWrapper';
import {log as logToServer} from '../api/logger';

const nativeCsrfRequest =
    (global.window && global.window.ha && global.window.ha.csrfTokenRequest) || null;
const csrfPromise = nativeCsrfRequest ? xhrWrapper(nativeCsrfRequest) : Promise.resolve('');

// register a catch handler so we can log any errors that occur during CSRF resolution to the backend
csrfPromise.catch((err) => {
    logToServer({
        message: 'CSRF promise resolution failed',
        error: err.toString(),
        stack: err.stack
    });
});

/**
 * Returns a promise that's resolved with the CSRF token after the `window.ha.csrfTokenRequest` XHR request has completed.
 *
 * @returns {Promise<string|null>}
 */
async function getCsrfToken() {
    const response = await csrfPromise;
    const jsonResponse = JSON.parse(response);

    return jsonResponse.csrfToken;
}

export default getCsrfToken;
export {getCsrfToken};
